import React from "react";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import clsx from "clsx";
import { usePropertiesStore } from "properties/listing/PropertiesPageContext";
import styles from "../_css/propertiesViewList.module.css";
import { PropertiesPaginator } from "properties/listing/PropertiesPaginator";
import { PropertiesNearList } from "properties/listing/PropertiesNearList";
import { MAP_OR_LIST_SELECTED, usePropertiesPageContext } from "properties/PropertiesPageContext";
import { AdvancedResearchSrPs } from "advancedResearches/AdvancedResearchSRPs";
import { Footer } from "main/footer/Footer";
import { PropertiesFaq } from "properties/PropertiesFaq";
import { useTranslation } from "react-i18next";
import { PropertiesBreadcrumb } from "properties/listing/PropertiesBreadcrumb";
import { Grid } from "@material-ui/core";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { PropertiesListLoader } from "properties/listing/PropertiesListLoader";
import { PropertiesViewListWithPlacements } from "properties/listing/PropertiesViewListWithPlacements";
import { PropertiesPopularSearch } from "properties/PropertiesPopularSearch";

export const PropertiesViewList = () => {
    const { t, i18n } = useTranslation();
    const propertiesStore = usePropertiesStore();
    const listStore = propertiesStore.getListStore(propertiesStore.purpose);
    const { mapOrListSelected } = usePropertiesPageContext();

    const displayNearProperties = !!(
        geoZonesStore.geoZone &&
        geoZonesStore.geoZone?._id &&
        (!listStore.count || listStore.count <= 6)
    );

    return (
        <>
            <div className={clsx("p_20 pt_0", styles.container)} id={"searchPage"}>
                <Grid alignItems="center" container spacing={4}>
                    <LoadableFromLoading
                        loading={listStore.currentLoadingState}
                        fallback={<PropertiesListLoader />}
                        renderer={() => {
                            return <PropertiesViewListWithPlacements />;
                        }}
                    />
                </Grid>
                <div className={clsx("flex_column_center gap_15 pt_40 pb_10 mb_40", styles.paginator)}>
                    <PropertiesPaginator className={styles.listStorePaginator} />
                    <PropertiesBreadcrumb center />
                </div>
                {displayNearProperties && <div className={styles.separator}>{t("propertiesPage.endOfResults")}</div>}
                {displayNearProperties && <PropertiesNearList />}
                <div className={clsx(styles.advancedResearches)}>
                    <AdvancedResearchSrPs />
                </div>
                {listStore.selectedPage === 1 && (
                    <PropertiesFaq geoZone={geoZonesStore.geoZone} purpose={propertiesStore.purpose} />
                )}

                {i18n.language === "fr" && <PropertiesPopularSearch />}
            </div>
            {mapOrListSelected === MAP_OR_LIST_SELECTED.LIST && <Footer />}
        </>
    );
};
